// A corrido render still running from an earlier visit on this device, read
// from the records the console and the corrido flow keep. Its own module so
// home (the Continue line) and /projects can ask without loading the
// Director console (components/landing/HeroSection.tsx re-exports it).

// The in-flight render records the console and the corrido flow keep. The
// TTLs mirror their owners (DirectorConsole ACTIVE_RUN_TTL_MS, CorridoChatFlow
// CORRIDO_ACTIVE_JOB_TTL_MS) so a long-dead record doesn't pin the page to
// corrido; the owners clear such records themselves once they mount.
const ACTIVE_RUN_RECORDS = [
  { key: 'director-console:active-run-v1', idField: 'runId', timeField: 'launchedAt', ttlMs: 2 * 60 * 60 * 1000 },
  { key: 'corrido:active-job-v1', idField: 'jobId', timeField: 'savedAt', ttlMs: 16 * 60 * 60 * 1000 },
] as const;

export function hasActiveRun(): boolean {
  if (typeof window === 'undefined') return false;
  return ACTIVE_RUN_RECORDS.some(({ key, idField, timeField, ttlMs }) => {
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) return false;
      const rec = JSON.parse(raw) as Record<string, unknown> | null;
      if (!rec || typeof rec !== 'object') return false;
      const id = rec[idField];
      if (typeof id !== 'string' || !id.trim()) return false;
      const at = rec[timeField];
      return typeof at === 'number' && Date.now() - at <= ttlMs;
    } catch {
      return false; // storage blocked (private mode, sandboxed frame) or a corrupt record
    }
  });
}
